import React from 'react';
import { LinearProgress, styled, Box } from '@mui/material';
import colors from 'src/utils/colors';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

export const StyledLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'barColor'
})<{ barColor: string }>(({ barColor }) => ({
  height: 12,
  width: '100%',
  borderRadius: '6px',
  backgroundColor: `${colors.surplusBudgetOpaque}`,
  '& .MuiLinearProgress-bar': {
    backgroundColor: barColor,
    borderRadius: 5
  }
}));

export const LegendPill = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'pillColor'
})<{ pillColor: string }>(({ pillColor }) => ({
  width: 12,
  height: 3,
  backgroundColor: pillColor,
  borderRadius: 3,
  display: 'inline-block'
}));

interface TextLinearProgressProps {
  mainValue: {
    value: number;
    color: string;
  };
  comparisonValue?: {
    value: number;
    color: string;
  };
}

export const TextLinearProgress = ({ mainValue, comparisonValue }: TextLinearProgressProps) => {
  return (
    <Flex flexDirection="column" gap={11} alignItems="center" width="100%" justifyContent="center">
      <Flex alignItems="center" gap={16} width="100%">
        <Text
          variant="body2"
          sx={{
            width: '35px',
            flexShrink: 0,
            textAlign: 'right'
          }}
        >
          {mainValue.value.toFixed(0)}%
        </Text>
        <StyledLinearProgress variant="determinate" value={mainValue.value} barColor={mainValue.color} />
      </Flex>
      {comparisonValue && (
        <Flex alignItems="center" gap={16} width="100%">
          <Text variant="body2" sx={{ width: '35px', flexShrink: 0, textAlign: 'right' }}>
            {comparisonValue.value.toFixed(0)}%
          </Text>
          <StyledLinearProgress variant="determinate" value={comparisonValue.value} barColor={comparisonValue.color} />
        </Flex>
      )}
    </Flex>
  );
};
